import routes, {HOME_ROUTE_NAME} from '@routes/config';
export default [
    {
        path: '',
        redirect: HOME_ROUTE_NAME,
        component: () => import( /* webpackChunkName: "App" */ '@views/App'),
        meta: {
            auth: true
        },
        children: [
            {
                path: routes.landing.home,
                name: routes.landing.home,
                component: () => import(/* webpackChunkName: "LandingHome" */ '@components/Home')
            },
            {
                path: routes.landing.resetpassword,
                name: routes.landing.resetpassword,
                component: () => import(/* webpackChunkName: "ResetPassword" */ '@components/ResetPassword')
            },
            {
                path: routes.landing.about,
                name: routes.landing.about,
                component: () => import(/* webpackChunkName: "About" */ '@components/About')
            },
            {
                path: routes.landing.contact,
                name: routes.landing.contact,
                component: () => import(/* webpackChunkName: "Contact" */ '@components/Contact')
            },
            {
                path: routes.landing.my_account,
                name: routes.landing.my_account,
                component: () => import(/* webpackChunkName: "MyAccount" */ '@components/MyAccount')
            },
            {
                path: routes.landing.my_contacts,
                name: routes.landing.my_contacts,
                props: {state: 'open'},
                component: () => import(/* webpackChunkName: "MyContacts" */ '@components/contact/MyContacts')
            },
            {
                path: routes.landing.my_contacts_history,
                name: routes.landing.my_contacts_history,
                props: {state: 'closed'},
                component: () => import(/* webpackChunkName: "MyContacts" */ '@components/contact/MyContacts')
            },
            {
                path: routes.landing.contact_center,
                name: routes.landing.contact_center,
                component: () => import(/* webpackChunkName: "ContactInbox" */ '@components/contact/Inbox')
            },
            {
                path: routes.landing.contact_center_settings,
                name: routes.landing.contact_center_settings,
                component: () => import(/* webpackChunkName: "ContactSettings" */ '@components/contact/Settings')
            },
            {
                path: routes.landing.faq,
                name: routes.landing.faq,
                component: () => import(/* webpackChunkName: "FAQ" */ '@components/Faq')
            },
            {
              path: routes.landing.my_profile,
              name: routes.landing.my_profile,
              component: () => import(/* webpackChunkName: "My_Profile" */ '@components/user/Profile')
            },
            {
              path: 'profile',
              name: routes.user.profile,
              component: () => import(/* webpackChunkName: "Profile" */ '@components/user/Profile')
            },
            {
              path: routes.user.index,
              name: routes.user.index,
              component: () => import(/* webpackChunkName: "User" */ '@components/user/Index')
            },
        ]
    },
];
